// import { getLocale } from '@/i18n/i18n-store'
export const prefix = 'front_api'
export const env = import.meta.env.MODE

export const getLanguageEnv = (): 'zh-CN' | 'en-US' | 'th-TH' | 'ms-MY' => {
  // In test environment, check URL query parameter first with highest priority
  if (env === 'test' || env === 'dev') {
    const urlParams = new URLSearchParams(window.location.search)
    const localeFromQuery = urlParams.get('locale')

    if (localeFromQuery) {
      const validLocales: Record<string, 'zh-CN' | 'en-US' | 'th-TH' | 'ms-MY'> = {
        'zh-CN': 'zh-CN',
        'en-US': 'en-US',
        'th-TH': 'th-TH',
        'ms-MY': 'ms-MY',
        zh: 'zh-CN',
        en: 'en-US',
        th: 'th-TH',
        ms: 'ms-MY',
        my: 'ms-MY'
      }

      if (validLocales[localeFromQuery]) {
        return validLocales[localeFromQuery]
      }
    }
  }

  const hostname = window.location.hostname

  // Extract the lowest level subdomain
  const lowestSubdomain = hostname.split('.')[0]

  // Map subdomains to languages (support both old format like 'en' and new format like 'en-test-ad')
  const subdomainToLang: Record<string, 'en-US' | 'th-TH' | 'ms-MY'> = {
    en: 'en-US',
    my: 'ms-MY',
    th: 'th-TH'
  }

  // Check if subdomain starts with a known language prefix (e.g., en-test-ad)
  const knownPrefixes = ['en-', 'th-', 'my-']
  for (const prefix of knownPrefixes) {
    if (lowestSubdomain.startsWith(prefix)) {
      const langKey = prefix.replace('-', '')
      return subdomainToLang[langKey]
    }
  }

  // Check old format (e.g., 'en', 'th', 'my')
  const lang = subdomainToLang[lowestSubdomain]
  if (lang) {
    return lang
  }

  // Default to Chinese for all other cases
  return 'zh-CN'
}

const langEnv = getLanguageEnv()

export const is_region_th = langEnv === 'th-TH'

export const getServersDomain = () => {
  // 前台：test-front-sa.aiadfly.com
  // 后台：test-back-sa.aiadfly.com

  // const map: any = {
  //   prod: 'https://front-v1.aiadfly.com',
  //   mock: 'http://localhost:3040',
  //   test: 'https://test-front-new.aiadfly.com',
  //   // test: 'http://10.147.34.132:16666',
  // }

  const cn_domain_conf: any = {
    prod: 'https://front-v1.aiadfly.com',
    mock: 'http://localhost:3040',
    test: 'https://test-front-new.aiadfly.com'
    // test: 'http://10.147.34.33:17666'
    // test: 'http://10.147.34.33:17666',
  }

  const langMap = {
    'zh-CN': cn_domain_conf,
    'en-US': cn_domain_conf,
    'ms-MY': cn_domain_conf,
    'th-TH': cn_domain_conf // 现在所有语言都使用相同的域名配置
  }

  return langMap[langEnv][env] + `/${prefix}`
}

export const getWsDomain = () => {
  const cn_domain_conf: any = {
    prod: 'wss://front-v1.aiadfly.com/ws/front',
    // test: 'ws://10.87.2.131:16666/ws/front',
    test: 'wss://test-front-new.aiadfly.com/ws/front',
    dev: 'ws://10.87.2.131:16666/ws/front'
  }

  const langMap = {
    'zh-CN': cn_domain_conf,
    'en-US': cn_domain_conf,
    'ms-MY': cn_domain_conf,
    'th-TH': cn_domain_conf // 现在所有语言都使用相同的 WebSocket 配置
  }

  return langMap[langEnv][env]
}

export const getSeeDomain = () => {
  const cn_domain_conf: any = {
    prod: 'https://test-fe.aiadfly.com/tool/see/reportData',
    test: 'https://test-fe.aiadfly.com/tool/see/reportData',
    dev: 'http://localhost:2222/tool/see/reportData'
  }

  const langMap = {
    'zh-CN': cn_domain_conf,
    'en-US': cn_domain_conf,
    'ms-MY': cn_domain_conf,
    'th-TH': cn_domain_conf // 现在所有语言都使用相同的配置
  }

  return langMap[langEnv][env]
}

export const getEsignAddress = () => {
  const esign_conf: any = {
    prod: 'https://web.esign.cn/workspace/home',
    test: 'https://smlh5.esign.cn/usercenterFront/login/web',
    dev: 'https://smlh5.esign.cn/usercenterFront/login/web'
  }
  return esign_conf[env]
}

export const getAgentDomain = () => {
  const agent_conf: Record<string, string> = {
    prod: 'https://ai-agent-v1.aiadfly.com',
    test: 'https://aiagent-dev.aiadfly.com',
    dev: 'https://aiagent-dev.aiadfly.com'
  }
  return agent_conf[env] ?? agent_conf.test
}
